import { render, staticRenderFns } from "./kjyr.vue?vue&type=template&id=16d127ae&scoped=true&"
import script from "./kjyr.vue?vue&type=script&lang=js&"
export * from "./kjyr.vue?vue&type=script&lang=js&"
import style0 from "./kjyr.vue?vue&type=style&index=0&id=16d127ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d127ae",
  null
  
)

export default component.exports